// Libs
import { createSlice } from '@reduxjs/toolkit';
import { createSettingGoal, getDetailGoal } from './goalThunk';
// Others

export interface IGoalState {
  isRefreshGoalList: boolean;
}

export const initialState: IGoalState = {
  isRefreshGoalList: false,
};

const goalSlice = createSlice({
  name: 'goal',
  initialState,
  reducers: {
    setRefreshGoalList(state, action) {
      state.isRefreshGoalList = action.payload;
    },
  },
  extraReducers(builder) {
    // GET: Get detail goal
    builder
      .addCase(getDetailGoal.pending, (_state) => {})
      .addCase(getDetailGoal.fulfilled, (_state) => {})
      .addCase(getDetailGoal.rejected, (_state) => {});

    // POST: Create setting goal
    builder
      .addCase(createSettingGoal.pending, (_state) => {})
      .addCase(createSettingGoal.fulfilled, (state) => {
        state.isRefreshGoalList = true;
      })
      .addCase(createSettingGoal.rejected, (_state) => {});
  },
});

// Action
export const goalActions = goalSlice.actions;

// Selectors
// Reducer
const goalReducer = goalSlice.reducer;
export default goalReducer;
